// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0824c0d0","749":"b477b8f9","903":"de2d3297"}[chunkId] + ".chunk.js";
};